import React, { Component } from 'react'
import Select from 'react-select'
import { SmallText, fonts } from 'app/common/typography'
import styled from 'styled-components'
import { colors } from 'shared/assets/styles'
import { FormattedMessage, injectIntl } from 'react-intl'
import type { IntlShape } from 'react-intl'

const { grey } = colors

export type SelectOption = {
    value: string,
    label: string
}

type Props = {
    value: string,
    labelKey?: string,
    labelColor?: string,
    name: string,
    options: Array<SelectOption>,
    placeholderKey?: string,
    onChange: (name: string, value: string) => void,
    onBlur?: (name: string, value: boolean) => void,
    className?: string,
    TextStyle?: any,
    intl: IntlShape
}

class ReactSelectComponent extends Component<Props> {
    handleChange = value => {
        const { onChange, name } = this.props
        onChange(name, value)
    }

    handleBlur = () => {
        const { onBlur, name } = this.props
        onBlur && onBlur(name, true)
    }

    render() {
        const {
            value,
            options,
            labelKey,
            labelColor = grey,
            name,
            placeholderKey,
            TextStyle = SmallText,
            intl
        } = this.props
        return (
            <div style={{ margin: '1rem 0' }}>
                {!!labelKey && (
                    <FormattedMessage id={labelKey}>
                        {(text: string) => (
                            <TextStyle color={labelColor}>{text}</TextStyle>
                        )}
                    </FormattedMessage>
                )}
                <StyledSelect
                    id={name}
                    options={options}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    value={value}
                    placeholder={intl.formatMessage({ id: placeholderKey })}
                />
            </div>
        )
    }
}

const StyledSelect = styled(Select)`
    outline: 0;
    border: none;
    width: 100%;
    -webkit-appearance: none;
    font-family: ${fonts.roboto};
    background: transparent;
    font-size: 16px;
    padding: 0;
    cursor: pointer;
    margin-top: 8px;
`

const ReactSelect = injectIntl(ReactSelectComponent)

export { ReactSelect }
